import React from "react";
import PropTypes from "prop-types";

const Steps = ({ step, currentStep, title }) => {
  const stepNumber = step + 1;
  const stepActive = currentStep === stepNumber;
  const stepCompleted = currentStep > stepNumber;

  /**
   * Returns an array with the classes for a step element and its text element.
   * @returns {Array} An array containing the classes for the step element and its text element.
   */
  const getStepClasses = () => {
    // Initialize the array with the classes for the step element
    const classes = [
      "grid size-7.5 md:h-9 md:w-9 place-items-center rounded-full text-ft15-18.29-0.3"
    ];

    // Initialize the array with the classes for the text element
    const textClasses = [
      "mt-5.5 font-MontserratMedium text-ft12-21 md:text-ft15-18.29-0.3"
    ];

    // Check if the step is active
    if (stepActive) {
      classes.push(
        "border border-purple-6C36B0 bg-white text-purple-6C36B0 font-PoppinsMedium text-ft18-27-0.36"
      );
      textClasses.push("text-black-000000");
    }
    // Check if the step is completed
    else if (stepCompleted) {
      classes.push(
        "bg-purple-6C36B0 text-white font-PoppinsMedium text-ft18-27-0.36"
      );
      textClasses.push("text-purple-6C36B0");
    }
    // Otherwise, the step is not active nor completed
    else {
      classes.push(
        "bg-grey-EEEEEE text-grey-B0B1B2 font-PoppinsMedium text-ft18-27-0.36"
      );
      textClasses.push("text-grey-C7CED6");
    }

    // Return the array of classes as a string
    return [classes.join(" "), textClasses.join(" ")];
  };

  return (
    <>
      <div className="flex items-center justify-center">
        <div className={getStepClasses()[0]}>{stepNumber}</div>
      </div>
      <div className={getStepClasses()[1]}>{title}</div>
    </>
  );
};

Steps.propTypes = {
  step: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  title: PropTypes.string
};
export default Steps;
